import { Table } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
import React from "react";
import { ThemedSpan } from "../../../components/utilities";
import classNames from "classnames";
import { useGetFactFindSummaryDetails } from "../hooks/useGetFactFindSummaryDetails";

function ClientDetailsGrid() {
    const { data, error, isLoading } = useGetFactFindSummaryDetails();
    const notSetStyle = { color: "red" };

     const statusTypeMap = {
        0: "Active",
        1: "Deceased",
        2: "POA Activated",
        3: "Inactive",
    };

    const clientDetails = React.useMemo(() => {
        if (!data) {
            return []
        }
        return data.clientAccounts.map((el) => {
            const isClientActive = el.status === 0;
            const isClientAMLExpired = el.amlDocuments?.some(aml => aml.amlExpiryDate && moment(aml.amlExpiryDate).isBefore(moment(), 'day'));
            const isClientAMLMissing = (!el.amlDocuments || el.amlDocuments.length === 0) || el.amlDocuments?.some(aml => aml.amlUploadedDate === null);
            let amlStatus = '';
            let amlStatusStyle = { color: 'black' };

            if (!isClientActive) {
                amlStatus = statusTypeMap[el.status];
            }
            else if (isClientAMLMissing) {
                amlStatus = 'AML Missing';
                amlStatusStyle = { color: "red" };
            }
            else if (isClientAMLExpired) {
                amlStatus = 'AML Expired';
                amlStatusStyle = { color: "red" };
            }
            else {
                amlStatus = 'AML Verified';
                amlStatusStyle = { color: "green" };
            }
            return {
                ...el,
                amlStatus,
                amlStatusStyle,
            };
        })
    }, [data])

    if (isLoading) return (
        <Skeleton height={300} />
    )

    if (error) return <p>Error loading data</p>;
    if (!data) {
        return null;
    }

    return (
        <div className="table-responsive">
            <Table >
                <tbody>
                    <tr>
                        <th><ThemedSpan variant="primary">Name</ThemedSpan></th>
                        <th><ThemedSpan variant="primary">AML Status</ThemedSpan></th>
                        <th><ThemedSpan variant="primary">Date of Birth</ThemedSpan></th>
                        <th><ThemedSpan variant="primary">National Insurance No</ThemedSpan></th>
                        <th><ThemedSpan variant="primary">Life Stage</ThemedSpan></th>
                    </tr>
                    {
                        clientDetails.map((clientData, i) => (
                            <tr key={i}>
                                <td>{clientData.forenames} {clientData.surname}</td>
                                <td><span style={clientData.amlStatusStyle}>{clientData.amlStatus}</span></td>
                                <td className={classNames('default-font', { 'font-monospace': clientData.dateOfBirth != null })}>{clientData.dateOfBirth ? moment(clientData.dateOfBirth).format('DD/MM/YYYY') : <span style={notSetStyle}>Not Set</span>}</td>
                                <td>{clientData.nationalInsuranceNumber ? clientData.nationalInsuranceNumber : <span style={notSetStyle}>Not Set</span>}</td>
                                <td>{clientData.lifeStage ? clientData.lifeStage : <span style={notSetStyle}>Not Set</span>}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
        </div >
    )
}

export default ClientDetailsGrid;